import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleY = useSpring(scrollYProgress, { stiffness: 140, damping: 28, mass: 0.3 });

  return (
    <div
      data-testid="scroll-progress-indicator"
      className="fixed right-5 md:right-8 top-1/2 -translate-y-1/2 z-50 h-40 w-[1px] bg-white/25 mix-blend-difference pointer-events-none"
    >
      <motion.div
        style={{ scaleY, transformOrigin: "top" }}
        className="absolute inset-0 bg-white"
      />
    </div>
  );
}
